import { defineStore } from 'pinia';

export const useIndicatorsStore = defineStore('indicators', {
  state: () => ({
    filters: {
      type: 'CCDTI',
      unit: '',
      search: '',
      date: { startYear: '', startMonth: '', endYear: '', endMonth: '' }
    },
    // NOVO ESTADO: Armazena o modo de cada indicador pelo código
    // Ex: { 'Variavel_1...': 'bar', 'Indicador_2...': 'doughnut' }
    chartModes: {},
    reportMode: 'ambos'
  }),

  actions: {
    setFilter(key, value) {
      if (Object.prototype.hasOwnProperty.call(this.filters, key)) {
        this.filters[key] = value;
      }
    },

    setFilters(newFilters) {
      this.filters = { ...this.filters, ...newFilters };
    },

    setDateFilter(dateFilters) {
      this.filters.date = { ...dateFilters };
    },

    clearFilters() {
      this.filters = {
        type: 'CCDTI',
        unit: '',
        search: '',
        date: { startYear: '', startMonth: '', endYear: '', endMonth: '' }
      };
      this.chartModes = {};
    },

    // Salva o modo do gráfico
    setChartMode(codigo, mode) {
      this.chartModes[codigo] = mode;
    },

    // Salva a preferência de relatório
    setReportMode(mode) {
      this.reportMode = mode;
    }
  },

  persist: true
});